import React, { useState } from 'react';
import { Workflow } from 'lucide-react';
import ServiceFlowCanvas from './ServiceFlowCanvas';
import { ALL_FLOWS } from './flowsData';

export default function AutomatizacionesPage() {
  const [activeKey, setActiveKey] = useState(ALL_FLOWS[0].key);
  const activeFlow = ALL_FLOWS.find((f) => f.key === activeKey) || ALL_FLOWS[0];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a0a14] via-[#12081a] to-[#0a0a14] text-white p-6">
      <div className="mb-6 flex items-center gap-3">
        <div className="p-3 rounded-2xl bg-[#ff0080]/12 border border-[#ff0080]/35">
          <Workflow className="w-6 h-6" style={{ color: '#ff0080' }} />
        </div>
        <div>
          <h1 className="text-2xl font-bold" style={{ color: '#ff0080' }}>Automatizaciones</h1>
          <p className="text-sm text-white/50">
            Innovation · Mapas de flujo por servicio (representativos, aún sin ejecución real)
          </p>
        </div>
      </div>

      <div className="mb-5 flex flex-wrap items-center gap-2">
        {ALL_FLOWS.map((flow) => {
          const active = activeKey === flow.key;
          return (
            <button
              key={flow.key}
              onClick={() => setActiveKey(flow.key)}
              className={`inline-flex items-center gap-2 rounded-xl border px-4 py-2 text-sm font-medium transition-all ${
                active
                  ? 'border-[#ff0080]/60 bg-[#ff0080]/20 text-[#ffaacc] shadow-[0_0_18px_rgba(255,0,128,0.25)]'
                  : 'border-[#ff0080]/15 bg-black/20 text-white/60 hover:border-[#ff0080]/40 hover:text-white/85'
              }`}
            >
              {flow.label}
            </button>
          );
        })}
      </div>

      <ServiceFlowCanvas flow={activeFlow} />
    </div>
  );
}
